// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"a142fb36","474":"6d02b158","965":"ba12be91"}[chunkId] + ".chunk.css";
};